import { AnimatePresence } from 'framer-motion';
import MobileMenuDirectionAnimation from './MobileMenuDirectionAnimation';
import Search from '../../MobileSearch';
import MobileMenuTitle from './MobileMenuTitle';
import { Dictionary } from '@ts/dictionary';
import { useMemo } from 'react';

type MobileMenuTopProps = {
  menuDictionary: Dictionary;
  menuLevel: number;
  className?: string;
  onClose: () => void;
  topSlug?: string | null | undefined;
  topTitle?: string | null | undefined;
  currentNavigationLevel?: 'campaign';
};

export default function MobileMenuTop({
  onClose,
  menuDictionary,
  menuLevel,
  className,
  topSlug,
  topTitle,
  currentNavigationLevel,
}: MobileMenuTopProps) {
  const isFirstLevel = menuLevel === 0;

  return (
    <AnimatePresence initial={false} mode="popLayout">
      {isFirstLevel && currentNavigationLevel !== 'campaign' ? (
        <MobileMenuDirectionAnimation
          navigationDirection="left"
          key="mobile-menu-search"
          className={className}>
          <Search.Root dictionary={menuDictionary}>
            <Search.Form onClose={onClose}>
              <Search.Input className="border-t-0 p-4" onClose={onClose} />
            </Search.Form>
          </Search.Root>
        </MobileMenuDirectionAnimation>
      ) : (
        <MobileMenuDirectionAnimation
          navigationDirection="right"
          key={`mobile-menu-title`}
          className="py-[18px]">
          {topTitle ? (
            <MobileMenuTitle
              showAllTitle={menuDictionary.showAll}
              slug={topSlug}
              title={topTitle}
              onClick={onClose}
            />
          ) : (
            <div className="w-full" />
          )}
        </MobileMenuDirectionAnimation>
      )}
    </AnimatePresence>
  );
}
